// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DPADefault_wrapper____WNU","linkwrapper":"DPADefault_linkwrapper__38UKB"};